import React from 'react';

export default function FormTextRow({
    label,
    text,
    parentGridClass = 'tw-grid-cols-3',
    labelGridClass = 'tw-col-span-1',
    textGridClass = 'tw-col-span-2',
    containerClasses = '',
    isPreTag = false,
}) {
    return (
        <div className={parentGridClass + ' ' + containerClasses + ' tw-grid tw-gap-4'}>
            <div className={labelGridClass}>
                <h6 className="modal__heading">{label}</h6>
            </div>
            <div className={textGridClass}>{isPreTag ? <pre className="modal__text">{text}</pre> : <p className="modal__text">{text}</p>}</div>
        </div>
    );
}
